module.exports = __webpack_public_path__ + "static/goddard@2x-e965390505b4de2e19d5fc09ec9804fd.png";